<mat-toolbar>
  <div class="back" (click)="goBack()" matTooltip="Atrás" matTooltipPosition="right" (keyup)="$event.keyCode === 13 && goBack()" tabindex>
    <mat-icon >arrow_back_ios_new</mat-icon>
  </div>
  <div class="hide-print" >
    <span class="hide-mobile">{{adminService.getText('client','capitalize')}} </span>#{{client()?.id}}
  </div>
  <a mat-icon-button href="tel:{{client()?.phone}}" matTooltip="Llamar"><mat-icon>phone</mat-icon></a>
</mat-toolbar>
<div class="wrapper" #wrapper>
  

  <mat-card>
    <mat-card-content>
      @if (loading()) {
        <div class="skeleton-wrapper">
          <div class="skeleton skeleton-header"></div>
          <div class="form-row">
            <div class="skeleton skeleton-box"></div>
            <div class="skeleton skeleton-box"></div>
            <div class="skeleton skeleton-box"></div>
            <div class="skeleton skeleton-box"></div>
            <div class="skeleton skeleton-box"></div>
            <div class="skeleton skeleton-box"></div>
          </div>
  
          <div class="skeleton skeleton-square"></div>
  
          <div class="skeleton skeleton-vehicle"></div>
        </div>
      }
      @if (client() && !loading()) {
        <div class="client">
          <div class="header">
            <div class="date">
              <span>Fecha Registro: {{client().created_at | date:'shortDate'}}</span>
              <div class="expander">
                <div class="only-print" style="font-weight: bold">
                  {{adminService.getText('client','uppercase')}}#{{client().correlative_id}}
                </div>
  
              </div>
              <span class="right">Última Actualización: {{client().updated_at | date:'shortDate'}}</span>
            </div>
            <div class="title">
              <div class="logo">
                <img [src]="company_logo">
              </div>
            </div>
          </div>
          <div class="content">
            @if ((roleService.can('update','client') | async)) {
              <app-client-form
                [parentFormGroup]="clientForm"
                [clientMode]="true"
                [showRating]="true"
                [enableRating]="true"
              ></app-client-form>
              <div class="subtitle">Dirección de Facturación</div>
              <app-billing-info-form
                [entity]="client()"
                entity_type="Client"
              >
              </app-billing-info-form>
            } @else {
              <ng-container>
                <div class="info">
                  <div class="name">Nombre</div>
                  <div class="value">{{client().name || 'No existe el '+adminService.getText('client')}}</div>

                  <div class="name">{{adminService.getText('client_identifier')}}</div>
                  <div class="value">{{client().rut | identifier}}</div>

                  <div class="name">Dirección</div>
                  <div class="value">{{client().address}}, {{client().city}}</div>

                  <div class="name">E-mail</div>
                  <div class="value">{{client().email}}</div>

                  <div class="name">Teléfono</div>
                  <div class="value"><a href="tel:{{client().phone}}" class="phone"><i class="fa fa-phone"></i>{{client().phone}}</a></div>

                  <div class="name">Categoría</div>
                  <div class="value"><app-stars [stars]="client().rating"></app-stars></div>
                </div>

                <app-billing-info-form
                  [entity]="client()"
                  entity_type="Client"
                  [readOnly]="true"
                >
                </app-billing-info-form>
              </ng-container>
            }
            
            <br />
            @for (vehicle of sortVehicles(client().vehicles); track vehicle.identifier) {
              <div class="vehicle">
                <div class="title" go-to-details [element]="vehicle" type="Vehicle">
                  <div class="title-info">
                    <div class="icon">
                      <i class="fa fa-car"></i>
                    </div>
                    <div class="title-data">
                      <div class="first-line">{{vehicle.identifier}} - {{vehicle.brand_name}} {{vehicle.brand_model_name}}</div>
                      <div class="second-line">{{vehicle.chasis}}</div>
                    </div>
                  </div>
                  @if (vehicle.kms) {
                    <div class="kms">{{vehicle.kms | currency:'':'':'0.0-0'}} KMS</div>
                  }
                </div>
                <div class="orders">
                  <div class="card order-card" *ngFor="let order of vehicle.orders; let last = last"
                      [class.ended-at]="order.ended_at"
                      [class.completed-at]="order.completed_at && !order.ended_at"
                      [class.check-in-time]="order.check_in_time && !order.completed_at && !order.ended_at"
                      [class.booking-time]="order.booking_date && !order.check_in_time && !order.ended_at"
                      (click)="openOrder(order)"
                  >
                    <div class="icon">
                      <i class="fa fa-check-double" *ngIf="order.ended_at"></i>
                      <i class="fa fa-check" *ngIf="order.completed_at && !order.ended_at"></i>
                      <i class="fa fa-wrench" *ngIf="order.check_in_time && !order.completed_at"></i>
                      <i class="fa fa-clock" *ngIf="order.booking_date && !order.check_in_time && !order.ended_at"></i>
                    </div>
                    <div class="requirement">
                      <div>{{order.requirement_name}}</div>
                    </div>
                    <div class="order-info">
                      <div>KMS: {{order.kms | currency:'':'':'0.0-0'}}</div>
                      <div *ngIf="order.ended_at">Entregado: {{order.ended_at | date}}</div>
                      <div *ngIf="order.completed_at && !order.ended_at">Completado: {{order.completed_at | date}}</div>
                      <div *ngIf="order.check_in_time && !order.completed_at">Ingresado: {{order.check_in_time | date}}</div>
                      <div *ngIf="order.booking_date && !order.check_in_time && !order.ended_at">Agendado: {{order.booking_date | date:'shortDate'}}</div>
                    </div>
                  </div>
                  <div class="order-card" (click)="createBooking(vehicle)">
                    <div class="icon">
                      <i class="fa fa-calendar-plus"></i>
                    </div>
                    <div class="requirement">
                      <div>Agendar vehiculo</div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </mat-card-content>
  </mat-card>

  @if (forbidden()) {
    <div class="no-access">
      <i class="fa fa-warning"></i>
      No tienes acceso a esta información
    </div>
  }
</div>

<mat-toolbar>
  <div class="expander"></div>
  @if (roleService.can('update','client') | async) {
    <button 
      mat-raised-button
      color="primary"
      (click)="saveClient()"
      [disabled]="!clientForm.valid || loading() || saving()"
    >
        <i class="fa fa-save" style="margin-right: 0"></i>
    </button>
  }
</mat-toolbar>

